import React from "react";

const testimonials = [
  {
    name: "Rajiv Sharma",
    role: "IT Manager, TechPro Ltd.",
    feedback:
      "New Krishna Technologies has completely transformed our network infrastructure. Their team is responsive, professional, and knowledgeable.",
  },
  {
    name: "Priya Desai",
    role: "Director, GreenField Enterprises",
    feedback:
      "We trust NKT for all our IT needs. Their AMC support is top-notch and their security solutions are reliable.",
  },
  {
    name: "Anil Mehra",
    role: "CIO, Delta Systems",
    feedback:
      "They helped us upgrade our server setup with minimal downtime. Very satisfied with the quality and speed of execution.",
  },
];

const Testimonials = () => {
  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-12">
          What Our Clients Say
        </h2>

        <div className="grid gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gray-50 border border-gray-100 p-6 rounded-xl shadow-sm hover:shadow-md transition"
            >
              <p className="text-gray-700 text-sm mb-4 italic">
                “{testimonial.feedback}”
              </p>
              <div className="mt-4 text-sm text-gray-800 font-semibold">
                {testimonial.name}
              </div>
              <div className="text-xs text-gray-500">{testimonial.role}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
